<template>
  <md-input-container :class="['tdl-typeahead', themeClass, classes]" ref="parent">
    <div class="selector-icon" v-if="addArrowDown && !onlyChips" v-on:click="requestFocus()"></div>
    <slot name="icon"></slot>
    <label for="autocomplete-input-mobile" v-if="inputLabel && isMobile">{{ inputLabel }}</label>
    <label for="autocomplete-input" v-if="inputLabel && !isMobile">{{ inputLabel }}</label>

    <div class="md-chips" v-on:click="requestFocus()">
      <template v-if="!(selectedItems.length === 1 && maxItems === 1)">
        <md-chip
          v-for="chip in selectedItems"
          md-deletable
          :cancelLabel="cancelLabel"
          @delete="handleItemRemoved(chip)"
          :key="getId(chip)"
          ref="chips"
        >
          <slot name="chip" :value="chip">{{ getText(chip) }}</slot>
        </md-chip>
      </template>

      <div v-if="selectedItems.length === 1 && maxItems === 1">
        <md-chip md-deletable :cancelLabel="cancelLabel" @delete="handleItemRemoved(selectedItems[0])" ref="chips">
          <slot name="chip" :value="selectedItems[0]">{{ getText(selectedItems[0]) }}</slot>
        </md-chip>
      </div>

      <template v-if="isMobile">
        <tdl-typeahead-dialog
          :selected-items="selectedItems"
          :disabled="disabled || disabledInput || null"
          :add-new-item="addNewItem || onlyChips"
          :only-chips="onlyChips"
          :loading="loading"
          :item-factory="itemFactory"
          :item-list="itemList"
          :excluded-list="excludedList"
          :text-attribute="textAttribute"
          :soft-list="softList"
          :id-attribute="idAttribute"
          :min-chars="minChars"
          :add-item-on-keypress="addItemOnKeypress"
          @query-changed="handleQueryChanged"
          @item-selected="handleItemSelected"
          @item-removed="handleItemRemoved"
          @focused="handleFocus"
          @next-page="handleNextPage"
          :grouped="grouped"
          :empty-values-message="emptyValuesMessage"
          ref="delegatedTypeahead"
        >
          <template #mobileCreate="{ query, queryInItemExcludedList }">
            <slot v-if="hasCreateSlot" name="create" :query="query"></slot>
            <template v-else-if="softTitle || query.length >= minChars">
              <md-icon
                :mdSvg="
                  softList && query.length < minChars ? mdiKeyboard : queryInItemExcludedList ? mdiAlert : mdiPlusCircle
                "
              />
              <div class="md-list-text-container">
                <span v-if="!queryInItemExcludedList"
                  ><b>{{ query }}</b></span
                >
                <span>
                  {{
                    softList && query.length < minChars
                      ? softTitle
                      : queryInItemExcludedList
                      ? excludedMessage
                      : addNewMessage
                  }}
                </span>
              </div>
            </template>
          </template>
          <template #mobileItem="{ item, formatted }">
            <div v-if="hasItemSlot">
              <slot name="item" :item="item" :formatted="formatted"></slot>
            </div>
            <div v-else>
              <span v-html="formatted"></span>
            </div>
          </template>
          <template #mobileChip="{ value }">
            <slot v-if="hasChipSlot" name="chip" :value="value"></slot>
            <template v-else>{{ getText(value) }}</template>
          </template>
        </tdl-typeahead-dialog>
      </template>
      <template v-else>
        <tdl-typeahead-list
          :only-regular-characters="onlyRegularCharacters"
          :only-chips="onlyChips"
          :selected-items="selectedItems"
          :disabled="disabled || disabledInput || null"
          :add-new-item="addNewItem || onlyChips"
          :loading="loading"
          :item-list="itemList"
          :excluded-list="excludedList"
          :item-list-fixed="desktopItemListFixed"
          :search-hint-mode="desktopSearchHintMode"
          :add-item-on-keypress="addItemOnKeypress"
          :item-factory="itemFactory"
          :show-arrow-down="addArrowDown"
          :text-attribute="textAttribute"
          :soft-list="softList"
          :softTitle="softTitle"
          :disable-max-width="disableMaxWidth"
          :min-chars="minChars"
          @query-changed="handleQueryChanged"
          @item-selected="handleItemSelected"
          @item-removed="handleItemRemoved"
          @focused="handleFocus"
          :enabled-scroll="enabledScroll"
          :force-close="forceClose"
          :id-attribute="idAttribute"
          :grouped="grouped"
          :empty-values-message="emptyValuesMessage"
          @next-page="handleNextPage"
          ref="delegatedTypeahead"
        >
          <template #desktopCreate="{ query, queryInItemExcludedList }">
            <slot v-if="hasCreateSlot" name="create" :query="query"></slot>
            <template v-else>
              <md-icon
                :mdSvg="
                  softList && query.length < minChars ? mdiKeyboard : queryInItemExcludedList ? mdiAlert : mdiPlusCircle
                "
              />
              <div class="md-list-text-container">
                <span v-if="!queryInItemExcludedList"
                  ><b>{{ query }}</b></span
                >
                <span>{{
                  softList && query.length < minChars
                    ? softTitle
                    : queryInItemExcludedList
                    ? excludedMessage
                    : addNewMessage
                }}</span>
              </div>
            </template>
          </template>
          <template #desktopItem="{ item, formatted }">
            <slot v-if="hasItemSlot" name="item" :item="item" :formatted="formatted"></slot>
            <template v-else>
              <span v-html="formatted"></span>
            </template>
          </template>
        </tdl-typeahead-list>
      </template>
    </div>
    <slot></slot>
  </md-input-container>
</template>

<script src="./tdlTypeahead.mjs"></script>
<style src="./tdlTypeahead.scss" lang="scss"></style>
